
import { Component, Vue } from 'vue-property-decorator'
import moment, { Moment } from 'moment'

import { ChartMessageService,StudentMessageAnalysisDto } from "@/api/service-proxies";
@Component({
    components: {

    },
})
export default class customIndex extends Vue {
    chartMessageService = new ChartMessageService();
    tableList= new StudentMessageAnalysisDto()
    isTableLoading =false
    mounted(){
        this.getAllSchoolChat()
    }
    getAllSchoolChat(){
      this.isTableLoading= true;
        this.chartMessageService.getStudentMessageAnalysis()
        .then((res)=>{
            this.tableList=res
        })
        .finally(()=>{
          this.isTableLoading = false;
        })
    }
}
